import { useToast } from '../components/ToastContext';
import { useEffect, useState } from 'react';
import { getStockLimit } from '../api/api';

export const useFetchStockLimit = () => {
  const [stockLimit, setStockLimit] = useState();
  const { showToast } = useToast();

  useEffect(() => {
    getStockLimit()
      .then((data) => setStockLimit(data))
      .catch(() => showToast('Something went wrong', 'error'));
  }, []);

  return stockLimit;
};
